'use client';

import Script from 'next/script';

declare global {
  interface Window {
    clarity: (...args: unknown[]) => void;
  }
}

interface ClarityAnalyticsProps {
  clarityId: string;
}

export default function ClarityAnalytics({ clarityId }: ClarityAnalyticsProps) {
  if (!clarityId) {
    return null;
  }

  return (
    <Script
      id="clarity-analytics"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");`
      }}
    />
  );
}
